// $(function () {
//     var page = 1;
//
//     $('body').on('click', '.news__more', function (event) {
//         event.preventDefault();
//
//         axios.post('/api/news/pagination-render', {
//             lang: $('html').attr('lang'),
//             page: page + 1,
//             current_year: $('body ul.post_box').data('current-year')
//         }).then(function (response) {
//             var data = response.data.data;
//
//             page = data.current_page;
//
//             if (page === data.last_page) {
//                 $('body .news__more').hide();
//             }
//
//             $('body .section__list .section__content ul').append(data.html);
//         }).catch(function (error) {
//             console.log(error.response)
//         });
//     });
// });

import './_api';

$(function () {
    var page = 1;
    var lang = $('html').attr('lang');
    var currentYear = !!$(`body ul.post_box`).data('current-year') ? $('body ul.post_box').data('current-year') : null;

    $('body').on('click', '.news__more', function (event) {
        event.preventDefault();

        page = page + 1;

        fetchData(`
            {
                newsPaginate(page: ${page}, lang: "${lang}", current_year: ${currentYear}, need_list_render: true) {
                    data {
                        id
                        published_time(date_string: true)
                        list_render
                    }
                    current_page
                    has_more_pages
                }
            }
        `).then(function (response) {
            $.each(response.newsPaginate.data, function (index, news) {
                $('body .section__list .section__content ul').append(news.list_render);
            });

            page = response.newsPaginate.current_page;

            if (!response.newsPaginate.has_more_pages) {
                $('body .news__more').remove();
            }
        });
    });
});
